export const RouteDefines = {

  // 首页部分
  ROUTER_NAME_HOME: 'Home',
  ROUTER_NAME_HOME_DASHBOARD: 'HomeDashboard',

  // 提现部分
  ROUTER_NAME_WITHDRAW_HOME: 'WithdrawHome',
  ROUTER_NAME_WITHDRAW_LIST: 'WithdrawList',

  // 店铺部分
  ROUTER_NAME_SHOP_HOME: 'ShopHome',
  ROUTER_NAME_SHOP_LIST: 'ShopList',

  // 在线收支
  ROUTER_NAME_ONLINE_TRADE_HOME: 'OnlineTradeHome',
  ROUTER_NAME_ONLINE_TRADE_LIST: 'OnlineTradeList',

  // 续期订单
  ROUTER_NAME_ORDER_INDEX_HOME: 'OrderIndexHome',
  ROUTER_NAME_ORDER_INDEX_LIST: 'OrderIndexList',

  // 账号部分
  ROUTER_NAME_OPERATOR_HOME: 'OperatorHome',
  ROUTER_NAME_OPERATOR_LIST: 'OperatorList',

  // 修改密码
  ROUTER_NAME_PASSWORD_HOME: 'PasswordHome',
  ROUTER_NAME_PASSWORD_INDEX: 'PasswordIndex',

  // 登录
  ROUTER_NAME_LOGIN: 'Login',

  // 素材管理
  ROUTER_NAME_MATERIAL_INDEX_HOME: 'MaterialHome',
  ROUTER_NAME_MATERIAL_INDEX_LIST: 'MaterialIndex',

  // 渠道管理
  ROUTER_NAME_CHANNEL_INDEX_HOME: 'ChannelHome',
  ROUTER_NAME_CHANNEL_INDEX_LIST: 'ChannelIndex',

  // 微信小程序 体验者
  ROUTER_NAME_WXXCX_TESTER_LIST: 'WxxcxTester',
  // 微信小程序 代码管理
  ROUTER_NAME_WXXCX_CODE_TEMPLATE_LIST: 'WxxcxCodeTemplate',
  // 微信小程序 发布体验管理
  ROUTER_NAME_WXXCX_CODE_COMMIT_LIST: 'WxxcxCodeCommit',
  // 微信小程序 发布体验管理
  ROUTER_NAME_WXXCX_CODE_SUBMIT_AUDIT_LIST: 'WxxcxCodeSubmitAudit'
}

// 店铺管理系统常量定义
export const Defines = {
  // 产品类型map对应
  SHOP_SOFTWARE_MAP: {
    'beauty': '美业'
  },
  SHOP_CODEVERSION_MAP: {
    'live': '完整版',
    'easy': '简略版'
  },
  SHOP_STATUS_MAP: {
    'expire': '过期',
    'valid': '有效'
  }
}



// WEBPACK FOOTER //
// ./src/utils/defines.js